import React from 'react'
import PropTypes from 'prop-types'
import { Layout, Menu } from 'antd'

const { Header } = Layout

const Navbar = props => (
  <Header>
    <div style={{
      float: 'left', color: '#fff', height: '64px', fontSize: '24px',
    }}
    >
      <img src="/images/logo.png" alt="Logo" style={{ height: '36px', marginRight: '10px' }} />
      {props.event.name}
    </div>
    <Menu
      theme="dark"
      mode="horizontal"
      defaultSelectedKeys={[props.selected]}
      style={{ lineHeight: '64px', float: 'right' }}
    >
      <Menu.Item key="1">
        <a href={`/${props.event.id}/dashboard`} rel="noopener noreferrer">Dashboard</a>
      </Menu.Item>
      <Menu.Item key="2">
        <a href={`/${props.event.id}/register`} rel="noopener noreferrer">Register</a>
      </Menu.Item>
      <Menu.Item key="3">
        <a href={`/${props.event.id}/check`} rel="noopener noreferrer">Check</a>
      </Menu.Item>
      <Menu.Item key="4">
        <a href={`/${props.event.id}/checkpoint`} rel="noopener noreferrer">Checkpoint</a>
      </Menu.Item>
    </Menu>
  </Header>
)
Navbar.propTypes = {
  selected: PropTypes.string.isRequired,
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js